import { isSameMonth, isBefore, startOfMonth } from 'date-fns';

export const formatMonth = (date: string) =>
    new Date(date).toLocaleString('en', { month: 'short' });

export const transformChartData = (data: { effectiveDate: string; value: string }[]) => {
    return data.map((item) => ({
        date: item.effectiveDate,
        apy: parseFloat(item.value),
    }));
};

export const calculateTrend = (chart: { date: string; apy: number }[]): string => {
    const now = new Date();
    const startOfCurrentMonth = startOfMonth(now);

    const currentMonthEntries = chart
        .filter((entry) => isSameMonth(new Date(entry.date), now))
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    if (currentMonthEntries.length === 0) {
        return 'N/A';
    }

    const lastCurrent = currentMonthEntries[currentMonthEntries.length - 1];

    const beforeMonthEntries = chart
        .filter((entry) => isBefore(new Date(entry.date), startOfCurrentMonth))
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    if (beforeMonthEntries.length === 0) {
        const firstCurrent = currentMonthEntries[0];
        return (lastCurrent.apy - firstCurrent.apy).toFixed(2);
    }

    const lastBeforeMonth = beforeMonthEntries[beforeMonthEntries.length - 1];

    if (!lastBeforeMonth) {
        return 'N/A';
    }

    return (lastCurrent.apy - lastBeforeMonth.apy).toFixed(2);
};

export const formatInterval = (chart: { date: string; apy: number }[]): string => {
    if (chart.length < 2) return '1 month';

    const first = new Date(chart[0].date);
    const last = new Date(chart[chart.length - 1].date);

    const formatter = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' });

    return `${formatter.format(first)} - ${formatter.format(last)}`;
};
